import { Box, Flex, Text } from '@mantine/core';
import { renderCell } from '../renderCell';
import {
  CELL_PADDING,
  FONT_SIZE,
  HEADER_BG,
  INDENT_SIZE,
  LINE_HEIGHT,
  TEXT_COLOR
} from '../tableConstants';
import { SeeMoreText } from './SeeMoreText';
import { ReadOnlyFundCell } from './ReadOnlyFundCell';
import { useReportContext, useReportContextOptional } from '../../../context/ReportContext';
import { useTableStyles } from '../tableConstants';
import { idCreator } from '../../../../../Project/utils/idCreator';

export const SingleFundRow = ({
  columnSchema,
  cellSchema,
  value,
  error,
  onChange,
  cellRefs,
  cellKey,
  onCellKeyDown,
  label,
  columnLevel,
  readOnly = false,
  fundId,
  fundName,
  tableName,
  fieldName,
  tableId,
  reportId,
  hasDrillDownFeature,
  isFromStaticTemplate,
  symbol,
  levelIndex
}) => {
  const reportContext = useReportContextOptional();
  const isStaticTemplateModalOpen = Boolean(reportContext?.isStaticTemplateModalOpen);
  const rowLabel = label || columnSchema?.name;
  const rowLevel = columnLevel || columnSchema?.level;
  const { isComparisonMode } = useReportContext();
  const { classes } = useTableStyles();
  const rowId = idCreator([tableName, fieldName, rowLevel, rowLabel].filter(Boolean).join('-'));

  return (
    <Flex id={`formpf-single-fund-row-${rowId}`} className={classes.borderBottom}>
      <Flex id={`formpf-single-fund-row-left-${rowId}`} maw="50%" miw="50%" bg="#fff">
        {Array.from({ length: levelIndex }).map((_, index) => (
          <Box
            key={index}
            align="center"
            justify="center"
            maw={INDENT_SIZE}
            miw={INDENT_SIZE}
            className={classes.borderRight}
          />
        ))}
        {rowLevel && (
          <Text
            id={`formpf-single-fund-row-level-${rowId}`}
            p={CELL_PADDING}
            className={classes.borderRight}
            ta="center"
            c={TEXT_COLOR}
            fz={FONT_SIZE}
            lh={LINE_HEIGHT}
            maw={INDENT_SIZE}
            miw={INDENT_SIZE}
          >
            {rowLevel}
          </Text>
        )}

        <Text
          id={`formpf-single-fund-row-label-${rowId}`}
          className={classes.borderRight}
          p={CELL_PADDING}
          flex="auto"
          c={TEXT_COLOR}
          fz={FONT_SIZE}
          lh={LINE_HEIGHT}
        >
          <SeeMoreText text={rowLabel} />
        </Text>
      </Flex>
      <Box
        id={`formpf-single-fund-row-value-${rowId}`}
        miw="50%"
        maw="50%"
        bg={readOnly || isFromStaticTemplate ? HEADER_BG : '#fff'}
      >
        {readOnly || isComparisonMode ? (
          <ReadOnlyFundCell
            id={`formpf-single-fund-row-readonly-${rowId}`}
            value={value || ''}
            error={error}
            showComment={readOnly}
            fundId={fundId}
            fundName={fundName}
            tableName={tableName}
            fieldName={fieldName}
            fieldOrder={rowLevel}
          />
        ) : (
          renderCell({
            columnSchema: cellSchema,
            value,
            onCellChange: onChange,
            error,
            cellRefs,
            cellKey,
            onCellKeyDown,
            fundId,
            fundName,
            tableName,
            fieldName,
            fieldOrder: rowLevel,
            tableId,
            reportId,
            title: rowLabel,
            hasDrillDownFeature:
              hasDrillDownFeature && value !== null && value !== undefined && reportId && tableId,
            isFromStaticTemplate,
            isStaticTemplateModalOpen,
            symbol
          })
        )}
      </Box>
    </Flex>
  );
};
